import React, { useRef } from "react";
import styled from "styled-components";
import ERATECertificate from "../../assets/image/erate.jpg";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";

const DocumentListBlock = styled.div`
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: 11px;
  color: #000000;
  background-color: #ffffff;
  border: none;
  border-radius: 5px;
  box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.05);
  padding: 0;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const DocumentListMenu = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionHeader = styled.div`
  font-family: 'Source Sans Pro', sans-serif !important;
  padding: 8px 12px;
  color: #ffffff;
  background: #2C4960;
  font-size: 16px;
  border-radius: 5px 5px 0px 0px;
  margin-bottom: 0;
`;

const ResourceList = styled.ul`
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: 11px;
  color: #000000;
  padding: 0;
  padding-left: 1em;
  margin: 0;
  list-style: disc inside none;
  text-indent: -1em;
  border-radius: 0px 0px 5px 5px;
  background-color: transparent;
`;

const ResourceItem = styled.li`
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: 0.85rem;
  color: #000000;
  margin: 0;
  padding: 5px 0 1.5em 1em;
  list-style: inside none;
  text-indent: -1em;

  a {
    display: block;
    width: 100%;
    font-family: 'Source Sans Pro', sans-serif !important;
    font-size: 0.85rem;
    padding-top: 10px;
    color: #2C4960;
    text-decoration: none;
    font-weight: normal;
    // padding: 0;
    outline: none;
    cursor: pointer;
    text-indent: -1em;

    &:hover {
      color: #F7941D;
    }
  }
`;

const CanvasContainer = styled.div`
  display: none;
`;

const DocumentDownload = ({ colors }) => {
  const canvasRef = useRef(null);
  const firstName = useSelector((state) => state.auth.user.first_name);
  const lastName = useSelector((state) => state.auth.user.last_name);

  const handleDownloadCertificate = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const blankCertificate = new Image();

    // Load the blank certificate image
    blankCertificate.src = ERATECertificate;
    blankCertificate.onload = () => {
      // Set canvas dimensions to match the certificate
      canvas.width = blankCertificate.width;
      canvas.height = blankCertificate.height;

      // Draw the blank certificate on the canvas
      ctx.drawImage(blankCertificate, 0, 0);

      // Add the name to the center of the certificate
      const userName = firstName + " " + lastName;
      ctx.font = "bold 50px Arial";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(userName, canvas.width / 2, canvas.height / 2);

      // Add the date to the bottom-right corner
      const currentDate = new Date().toLocaleDateString();
      ctx.font = "20px Arial"; // Smaller font for the date
      ctx.textAlign = "right";
      ctx.fillText(currentDate, canvas.width - 120, canvas.height - 170);

      const certificateImage = canvas.toDataURL("image/png");

      // Create a jsPDF document
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [canvas.width, canvas.height],
      });

      // Add the certificate image to the PDF with reduced size
      const scaledWidth = canvas.width ;
      const scaledHeight = canvas.height;

      pdf.addImage(certificateImage, "PNG", 0, 0, scaledWidth, scaledHeight);

      // Save the static, read-only PDF
      pdf.save(`${userName}_Certificate.pdf`);
    };
  };

  const subscriptionDocuments = [
    {
      title: "E-Rate Internet Safety Education Certificate - Download",
      key: "download",
    },
  ];

  return (
    <DocumentListBlock>
      <DocumentListMenu>
        <SectionHeader colors={colors}>Documents Download</SectionHeader>
        <ResourceList colors={colors}>
          {subscriptionDocuments?.map((resource, index) => (
            <ResourceItem key={index}>
              <a onClick={handleDownloadCertificate}>{resource.title}</a>
            </ResourceItem>
          ))}
        </ResourceList>
      </DocumentListMenu>
      <CanvasContainer>
        <canvas ref={canvasRef}></canvas>
      </CanvasContainer>
    </DocumentListBlock>
  );
};

export default DocumentDownload;
